'use client';

import { SliceComponentProps } from '@prismicio/react';
import cx from 'classnames';
import { FC } from 'react';

import { Typography } from '../../../../../design-system/components/typography/Typography';
import { TrustpilotMiniTrustScoreWidget } from '../../../../../shared/components/Trustpilot/MiniTrustScoreWidget';

import type { TrustpilotSlice } from '../../../../../core/Api/Prismic/PublicWebsite/types';

import style from './index.module.css';

export type TrustpilotProps = SliceComponentProps<TrustpilotSlice>;

const Trustpilot: FC<TrustpilotProps> = ({ slice }) => {
    const { title } = slice.primary;
    const hasTitle = Boolean(title);

    return (
        <section
            className={cx('layout-with-centered-content', style.layout)}
            data-slice-type={slice.slice_type}
            data-slice-variation={slice.variation}
        >
            <div className={cx('main-container', style.wrapper)}>
                {hasTitle ? (
                    <Typography as="h2" scale="secondary-s-bold" className={style.title}>
                        {title}
                    </Typography>
                ) : null}
                <div className={style.widget}>
                    <TrustpilotMiniTrustScoreWidget />
                </div>
            </div>
        </section>
    );
};

export default Trustpilot;
